import { connect } from 'react-redux';

import LearningAdminHeaderList from '../components/LearningAdminHeaderList';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  return {
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const LearningAdminHeaderListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminHeaderList);

export default LearningAdminHeaderListContainer;
